import { render, staticRenderFns } from "./orderView.vue?vue&type=template&id=97f452f4&scoped=true&"
import script from "./orderView.vue?vue&type=script&lang=js&"
export * from "./orderView.vue?vue&type=script&lang=js&"
import style0 from "./orderView.vue?vue&type=style&index=0&id=97f452f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f452f4",
  null
  
)

export default component.exports